import React, { useEffect, useState } from 'react';
import axios from '../../../library/axios';
import axiosApi from '../../../library/axios-lam-api';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { formatDate } from '../../../helpers/formatDate';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const EditPokjaComp = (props) => {
  // console.log(props.pokja);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [pokja, setPokja] = useState(props.pokja.namaPokja);
  const [listBab, setListBab] = useState([]);
  const [listSurvei, setListSurvei] = useState([]);
  const [showListBab, setshowListBab] = useState(true);
  const [idKegiatanAkreditasi, setidKegiatanAkreditasi] = useState(props.pokja.idKegiatanAkreditasi);
  const [idBabSelected, setIdBabSelected] = useState([]);
  const [idBabSelectedNew, setIdBabSelectedNew] = useState([]);


  const handleUpdate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      namaPokja: pokja,
      idKegiatanAkreditasi: idKegiatanAkreditasi,
      bab: idBabSelectedNew,
    };

    // console.log(props.pokja.id);
    // return false;
    axios({
      url: `/pokja/update-pokja-access-bab/${props.pokja.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully updated Pokja!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  const fetchData = async (id) => {
    const idKegiatanAkreditasi = props.pokja.idKegiatanAkreditasi !== "" ? props.pokja.idKegiatanAkreditasi : id
    try {
      const options = {
        url: `/getBabByIdKegiatanAkreditasi/${idKegiatanAkreditasi}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axiosApi(options);
      // console.log(data);
      // return false;
      setListBab(data);
      setshowListBab(true);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/pokja/edit.fetchData');
    }
  };

  const fetchList = async () => {
    try {
      const options = {
        url: '/getListSurveyByKodeRs/3509140',
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axiosApi(options);
      // console.log(data);
      // return false;
      setListSurvei(data);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/pokja/edit.fetchList');
    }
  };

  useEffect(() => {
    fetchList();
    fetchData();
  }, []);

  const handleChangePeriodeSurvei = (value) => {
    setidKegiatanAkreditasi(value);
    fetchData(value);
  };

  const handleClickIdBab = (id) => {
    const check = idBabSelected.includes(id)
    // console.log(check)
    if (check === false) {
      setIdBabSelected(idBabSelected => [...idBabSelected, id])
      setIdBabSelectedNew(idBabSelectedNew => [...idBabSelectedNew, { "idBab": id }])
    } else {
      const filterIdBabNew = idBabSelectedNew.filter((p) => p.idBab !== id)
      const filterIdBab = idBabSelected.filter((p) => p !== id)
      setIdBabSelectedNew(filterIdBabNew)
      setIdBabSelected(filterIdBab)
    }
  }

  useEffect(() => {
    setIdBabSelected(props.pokja.access_babs.map(bab =>
      bab.idBab,
    ));

    setIdBabSelectedNew(props.pokja.access_babs.map(bab => ({
      idBab: bab.idBab
    })));

  }, [props.pokja.access_babs]);

  // console.log(idBabSelectedNew)

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="pokja" className="col-sm-12 col-form-label required">
          Nama Kelompok Kerja
        </label>
        <div className="col-sm-12">
          <input
            type="text"
            className="form-control"
            id="pokja"
            autoComplete="off"
            onChange={(e) => setPokja(e.target.value)}
            value={pokja}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="pokja" className="col-sm-12 col-form-label required">
          Periode Survei
        </label>
        {listSurvei.map((item) => (
          <select
            className="form-select form-select-solid"
            data-control="select2"
            data-hide-search="true"
            data-placeholder=""
            name="periode_survei"
            onChange={(e) => handleChangePeriodeSurvei(e.target.value)}
            value={idKegiatanAkreditasi}
          >
            <option value>Pilih Periode Survei</option>
            <option value={item.IdKegiatanAkreditasi}> {formatDate(item.TglMulai)} S/D {formatDate(item.TglBerakhir)}</option>
          </select>
        ))}
      </div>

      {showListBab === true ? (
        <>
          {/*begin::Section*/}
          <div className="m-0">
            {/*begin::Heading*/}
            <div
              className="d-flex align-items-center collapsible py-3 toggle mb-0"
              data-bs-toggle="collapse"
              data-bs-target="#kt_job_1_1"
            >
              {/*begin::Icon*/}
              <div className="btn btn-sm btn-icon mw-20px btn-active-color-primary me-3">
                {/*begin::Svg Icon | path: icons/duotune/general/gen036.svg*/}
                <span className="svg-icon toggle-on svg-icon-primary svg-icon-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      opacity="0.3"
                      x={2}
                      y={2}
                      width={20}
                      height={20}
                      rx={5}
                      fill="black"
                    />
                    <rect
                      x="6.0104"
                      y="10.9247"
                      width={12}
                      height={2}
                      rx={1}
                      fill="black"
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
                {/*begin::Svg Icon | path: icons/duotune/general/gen035.svg*/}
                <span className="svg-icon toggle-off svg-icon-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      opacity="0.3"
                      x={2}
                      y={2}
                      width={20}
                      height={20}
                      rx={5}
                      fill="black"
                    />
                    <rect
                      x="10.8891"
                      y="17.8033"
                      width={12}
                      height={2}
                      rx={1}
                      transform="rotate(-90 10.8891 17.8033)"
                      fill="black"
                    />
                    <rect
                      x="6.01041"
                      y="10.9247"
                      width={12}
                      height={2}
                      rx={1}
                      fill="black"
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </div>
              {/*end::Icon*/}
              {/*begin::Title*/}
              <label
                htmlFor="list_bab"
                className="col-sm-4 col-form-label fw-bolder cursor-pointer mb-0"
              >
                Daftar Bab
              </label>
              {/*end::Title*/}
            </div>
            {/*end::Heading*/}
            {/*begin::Body*/}
            {listBab.map((item, i) => (
              <div id="kt_job_1_1" className="collapse show fs-6 ms-1">
                {/*begin::Item*/}
                <div className="mb-2">
                  {/*begin::Item*/}
                  <div className="d-flex align-items-center ps-10 mb-n1">
                    {/*begin::Label*/}
                    <label className="form-check form-check-custom form-check-solid me-1" htmlFor={item.IdBab}>
                      <input
                        className="form-check-input h-20px w-20px m-lg-2"
                        type="checkbox"
                        onClick={() => handleClickIdBab(item.IdBab)}
                        value={item.IdBab}
                        id={item.IdBab}
                        checked={idBabSelected.includes(item.IdBab)}
                      />
                    </label>
                    <div className="text-gray-600 fw-bold fs-6">
                      {i + 1}
                      {'. '}
                      {item.Deskripsi} {''}({item.Singkatan})
                    </div>

                    {/*end::Label*/}
                  </div>
                  {/*end::Item*/}
                </div>

                {/*end::Item*/}
              </div>
            ))}
            {/*end::Content*/}
            {/*begin::Separator*/}
            <div className="separator separator-dashed" />
            {/*end::Separator*/}
          </div>
        </>
      ) : (
        ''
      )}
      {/*end::Section*/}
      <div className="mt-10 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleUpdate()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditPokjaComp;
